<template>
  <div class="blast">
    <Aheader :realIndex="3"></Aheader>
    <div class="banner">
      <div>
        <p>Search for the highest similarity for your sequence of interest.</p>
        <div class="tab_button">
          <button @click="blastValTabChange('BLASTN')" :class="{active_button:blastVal === 'BLASTN'}">BLASTN</button>
          <button @click="blastValTabChange('BLASTP')" :class="{active_button:blastVal === 'BLASTP'}">BLASTP</button>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="gene-sequence">
        <div class="content-block-item">
          <el-row style="height: 100%">
            <el-row type="flex" justify="space-between">
              <span class="sub-title"
                >Please enter one or more FASTA sequences</span
              >
            </el-row>
            <el-row class="select-type">
              <span class="select">Methods</span>
              <el-radio-group v-model="selectType">
                <el-radio label="Upload File"></el-radio>
                <el-radio label="Raw File">
                  <span class="mar-top">
                    Raw File
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="Cannot exceed 1000000 characters"
                      placement="top"
                    >
                      <svg
                        t="1647932228140"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="4861"
                        width="16"
                        height="16"
                      >
                        <path
                          d="M512 64a448 448 0 1 0 448 448 448 448 0 0 0-448-448z m3.2 704a48 48 0 0 1-48-47.36 48.64 48.64 0 0 1 48-48 48 48 0 0 1 47.36 48 47.36 47.36 0 0 1-47.36 47.36z m80.64-271.36A131.84 131.84 0 0 0 547.84 576v32a33.28 33.28 0 0 1-64 0v-24.32a181.76 181.76 0 0 1 67.2-120.32 165.76 165.76 0 0 0 60.16-104.96 83.2 83.2 0 0 0-90.24-89.6c-64 0-99.84 41.6-101.76 119.68a32 32 0 0 1-31.36 28.8 31.36 31.36 0 0 1-30.72-28.8V384a154.24 154.24 0 0 1 163.84-166.4 135.04 135.04 0 0 1 147.2 140.8 196.48 196.48 0 0 1-72.32 138.24z"
                          p-id="4862"
                        ></path>
                      </svg>
                    </el-tooltip> </span
                ></el-radio>
              </el-radio-group>
            </el-row>
            <el-row class="textarea-wrap">
              <div class="upload" v-if="selectType === 'Upload File'">
                <el-upload
                  v-if="file === null && !loading"
                  class="sequence-upload"
                  drag
                  action="/"
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="fileInputHandleChange"
                  accept=".fasta, .fa, .fna"
                >
                  <img src="@/assets/img/upload.svg" alt="upload" />
                  <div class="el-upload__text">
                    Drag the file here, or<em>&nbsp;Click upload</em>
                  </div>
                </el-upload>
                <div
                  v-if="loading"
                  class="loading"
                  v-loading="loading"
                  element-loading-text="文件上传中"
                  element-loading-spinner="el-icon-loading"
                  style="z-index:1999"
                ></div>
                <div class="upload-suc" v-if="file !== null && !loading">
                  <div class="svg-box" @click="delFileInput">
                    <i class="el-icon-circle-close"></i>
                  </div>
                  <img src="@/assets/img/down-file.svg" alt="" />
                  <p>{{ file && file.name }}</p>
                </div>
              </div>
              <el-input
                v-if="selectType === 'Raw File'"
                type="textarea"
                v-model="fastatext"
                resize="none"
                @change="handleFastatextChange"
                maxlength="1000000"
              >
              </el-input>
            </el-row>
          </el-row>
        </div>
      </div>
      <Blast></Blast>
      <div class="btn-box">
        <el-button
          class="btn"
          @click="toResult"
          :disabled="$store.state.hasSubmit"
        >
          <span v-if="!$store.state.hasSubmit">Submit</span>
          <i class="el-icon-loading" v-else></i>
        </el-button>
      </div>
    </div>
    <Afooter></Afooter>
  </div>
</template>

<script>
import Aheader from '../../components/aheader.vue'
import Blast from '../../components/Blast.vue'
import Afooter from '../../components/afooter.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
import { Message } from 'element-ui'
import api from '../../utils/api'
export default {
  name: 'BlastPage',
  components: {
    Aheader,
    Blast,
    Afooter
  },
  data () {
    return {
      fastatext: '',
      selectType: 'Upload File',
      loading: false,
      file: null,
      path: null
    }
  },
  created () {
    this.$store.commit('toTop')
  },
  methods: {
    ...mapMutations(['updateBlastData', 'updateSequences', 'undateBlastVal']),
    ...mapActions(['handleSubmitData']),
    async toResult () {
      let res = await api.getSetCheckLogin()
      if (res === '' || (res.data && res.data.code === 200)) {
        if (this.selectType === 'Upload File') {
          this.updateSequences({ mode: 'upload-file' })
        } else {
          this.updateSequences({ mode: 'raw-input' })
        }
        this.handleSubmitData()
      } else {
        Message.error(res)
      }
    },
    async fileInputHandleChange (file) {
      let FileRaw = new FormData()
      FileRaw.append('file', file.raw)
      let res = await api.getSetCheckLogin()
      if (res === '' || (res.data && res.data.code === 200)) {
        this.loading = true
        api.uploadfile(FileRaw).then(res => {
          if (res.data.code === 200) {
            this.path =
              res.data.data.realSavePath + '/' + res.data.data.saveFilename
            this.file = file
            this.updateSequences({ textPath: this.path, mode: 'upload-file' })
            Message.success('File uploaded successfully')
          } else {
            Message.error(`${res.data.msg}`)
          }
          this.loading = false
        }).catch(err => {
          Message.error(err)
          this.loading = false
        })
      } else {
        Message.error('not logged in')
      }
      // 读文件内容
      // const file = this.$refs['file-input'].files[0]
      // var reader = new FileReader()
      // reader.onload = e => {
      //   this.fastatext = e.currentTarget.result
      //   this.handleFastatextChange()
      // }
      // reader.readAsText(file)
    },
    // 删除上传文件
    delFileInput () {
      this.file = null
      this.path = null
    },
    initUploadFile () {
      this.$nextTick(() => {
        this.$refs['file-input'].click()
      })
    },
    handleFastatextChange () {
      const { fastatext } = this
      let lineArray = fastatext.split('\n')
      if (
        fastatext === '' ||
        !fastatext.startsWith('>') ||
        lineArray.length < 2
      ) {
        Message.error('Wrong format of FASTA sequence')
        return false
      }
      let textArray = this._fastaToSequences(lineArray)
      this.updateSequences({ mode: 'raw-input', text: fastatext, textArray })
    },
    _fastaToSequences (lineArray) {
      // 工具函数：把fasta文本处理成数组
      let sequenceArray = []
      let seq = lineArray[0] + '\n'
      for (let i = 1; i < lineArray.length; i++) {
        let line = lineArray[i].trim()
        if (line.startsWith('>')) {
          sequenceArray.push(seq)
          seq = line + '\n'
        } else {
          seq += line
        }
      }
      sequenceArray.push(seq)
      return sequenceArray
    },
    blastValTabChange (val) {
      // 恢复初始化
      this.fastatext = ''
      this.selectType = 'Upload File'
      this.loading = false
      this.delFileInput()
      this.undateBlastVal(val)
    }
  },
  computed: {
    ...mapState(['blastVal'])
  },
  watch: {
    'this.$store.state.hasSubmit': function (newAl, oldAl) {
      // console.log(newAl)
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  margin-top: vw(81);
  min-width: vw(1200);
  height: vw(356);
  background-image: url('../../assets/img/blast-banner.png');
  background-size: 100% 100%;
  padding-top: vw(130);
  box-sizing: border-box;
  >div {
    width: vw(1200);
    height: vw(226);
    margin: 0 auto;
    position: relative;
    p {
      width: vw(900);
      font-size: vw(24);
      color: #333;
    }
    .tab_button{
      position: absolute;
      bottom: 0;
      left: 0;
      button{
        outline: none;
        border: none;
        background-color: #999999;
        color: #fff;
        font-size: vw(16);
        height: vw(42);
        width: vw(128);
        cursor: pointer;
      }
      .active_button{
        background-color: #05579E;
      }
    }
  }
}
.content {
  width: vw(1200);
  margin: 0 auto;

  .gene-sequence {
    margin-top: vw(40);
    .content-block-item {
      width: 100%;
      height: vw(300);
      background: #ffffff;
      border-radius: 4px;
      box-sizing: border-box;
      .sub-title {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 60px;
      }
      .sub-title-btn {
        color: #175690;
        cursor: pointer;
      }
      .sub-title-btn:hover {
        color: #026ebb;
      }
      .textarea-wrap {
        height: calc(100% - 80px);
        .upload {
          height: 100%;
          .sequence-upload {
            height: 100%;
            >>> .el-upload {
              width: 100%;
              height: 100%;
              .el-upload-dragger {
                width: 100%;
                height: 100%;
                &:hover {
                  border-color: $theme_color;
                }
                img {
                  height: 60%;
                  margin-top: vw(20);
                }
                .el-upload__text {
                  margin-top: vw(12);
                  color: #333333;
                  em {
                    color: $theme_color;
                  }
                }
              }
            }
          }
          .loading {
            height: 100%;
          }
          .upload-suc {
            width: 160px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            padding: 5px;
            box-sizing: border-box;
            border-radius: 4px;
            .svg-box {
              position: absolute;
              top: 4px;
              right: 8px;
              cursor: pointer;
              .el-icon-circle-close {
                color: #999;
                &:hover {
                  color: #e96565;
                }
              }
            }
            img {
              width: 100px;
              margin-bottom: 10px;
            }
            p {
              font-size: 16px;
              margin-bottom: 0;
              text-align: center;
              word-break: break-all;
            }
            &:hover {
              background-color: #f8f8f8;
            }
          }
        }
        .el-textarea {
          height: 100% !important;
          >>> textarea {
            display: block;
            width: 100% !important;
            height: 100% !important;
            background-color: #fff;
            font-family: Courier New;
            font-size: 16px;
            font-weight: 400;
            resize: none;
            border: 1px solid #ddd;
          }
        }
      }
      .select-type {
        position: relative;
        .select {
          position: absolute;
          top: 0;
          left: 0;
          line-height: 40px;
          height: 40px;
          font-size: 14px;
          color: #666;
        }
        .el-radio-group {
          margin-left: 120px;
          .el-radio {
            line-height: 40px;
            margin-right: 30px;
            &:last-child {
              margin-right: 0;
            }
            >>> .el-radio__label {
              color: #606266;
            }
            >>> .el-radio__input.is-checked .el-radio__inner{
              border-color: $theme_color;
              background: $theme_color;
            }
            >>> .el-radio__input.is-checked + .el-radio__label {
              color: #606266;
            }
            .mar-top {
              position: relative;
              svg {
                position: absolute;
                top: 2px;
                right: -18px;
                path {
                  fill: #666;
                }
                &:hover {
                  path {
                    fill: $theme_color;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .btn-box {
    text-align: center;
    .btn {
      margin-bottom: vw(137);
      margin-top: vw(30);
      color: #ffffff;
      font-size: vw(16);
      background-color: $theme_color;
      width: vw(160);
      height: vw(40);
      &:hover {
        background-color: $theme_color_hover;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/blast/blast.vue